<template>

  <div class="app" style="background-color: #ffffff">
    <Header ref="header" ></Header>

    <div class="conversion">
      <div data-v-108d3240="" data-v-25858e0c="" class="h-80 banner">
        <div data-v-108d3240="" class="container mx-auto px-4 py-10" style="width:auto !important;">
          <div data-v-108d3240="" class="hero h-60 flex flex-col justify-center items-center">
            <h1 data-v-108d3240="" class=" text-white" style="font-size: 40px;">
              将多个二维码合并成一个，随时修改、永久有效
            </h1>
            <h2 data-v-108d3240="" class="text-white mt-5 mb-10 font-light">
              智能微信群/个人号二维码活码营销引流工具，活码分渠道，自动切换避免限制
            </h2>
            <button data-v-108d3240="" @click="zh" class="btn-ani  shadow-xl px-6 text-lg py-3 text-afb-light border border-white bg-white  rounded">
              免费创建
            </button>
          </div>
        </div>
      </div>





      <div data-v-25858e0c="" class="container" style="background-color: #ffffff">
        <div data-v-25858e0c="" class="flex-col items-center justify-center flex " >
          <h2 data-v-25858e0c="" class="text-3xl mt-10">
            应用场景
          </h2>
          <span data-v-25858e0c="" class=" mt-5 text-gray-500 font-light">助力社群营销、加速群裂变、帮助您轻松批量管理微信群、客服微信等，提升推广转化效率</span>
        </div>

        <template>
          <el-tabs v-model="activName" type="border-card" :stretch="true" @tab-click="handleClick" style="width: 885px;border:0px;box-shadow:0px 0px;margin: auto">
            <el-tab-pane label="社群引流" name="first" :stretch="true" >
              <div style="width: 100%;height: 450px"> <img src="../assets/res/images/hm1.jpg" style="width: 100%;height: 100%"/></div>
            </el-tab-pane>
            <el-tab-pane label="个人号引流" name="second">
              <div style="width: 100%;height: 450px"> <img src="../assets/res/images/hm2.jpg" style="width: 100%;height: 100%"/></div>
          </el-tab-pane>
            <el-tab-pane label="线下推广" name="third">
              <div style="width: 100%;height: 450px"> <img src="../assets/res/images/hm3.jpg" style="width: 100%;height: 100%"/></div>
            </el-tab-pane>
            <el-tab-pane label="分组运营" name="fourth">
              <div style="width: 100%;height: 450px"> <img src="../assets/res/images/hm4.jpg" style="width: 100%;height: 100%"/></div>
            </el-tab-pane>
          </el-tabs>
        </template>
        <div data-v-25858e0c="" class="w-full flex justify-center mt-10 text-xl">
          <div data-v-25858e0c="" @click="zh" class="flex items-center justify-center border text-center rounded border-afb-light text-afb-light cursor-pointer" style="width: 224px; height: 56px;border: #2e6ab1 1px solid;margin-bottom: 60px" >
            立即使用
          </div>
        </div>
        <div data-v-197fc3f7="" data-v-25858e0c="">
          <div data-v-197fc3f7="" class="el-dialog__wrapper" style="display: none;">
            <div role="dialog" aria-modal="true" aria-label="dialog" class="el-dialog" style="margin-top: 10vh; width: 85%;">
              <div class="el-dialog__header"><span class="el-dialog__title"></span><button type="button" aria-label="Close" class="el-dialog__headerbtn">
                <i class="el-dialog__close el-icon el-icon-close"></i>
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div data-v-25858e0c="" class="hidden w-full h-full mx-auto sm:flex flex-col justify-center items-center pb-24 " style="background-color: rgb(247, 249, 253);">
          <div data-v-25858e0c="" class=" mb-12 flex flex-col justify-center items-center"><span data-v-25858e0c="" class=" text-3xl text-afb-gray mt-20">
            活码使用流程
          </span>
            <span data-v-25858e0c="" class=" mt-5 text-gray-500 font-light">
              突破个人号/群限制，通过活码将微信流量分流至多个群/个人号</span>
          </div>
          <div data-v-8aa184b6="" class="  -top-24 w-full left-0" style="border-radius: 50px;border: #2e6ab1 1px solid;width: 762px">
            <div data-v-8aa184b6="" class="flex justify-center w-full border border-afb-light rounded-3xl mx-auto" style="width: 780px;">
              <div data-v-8aa184b6="" class="bg-afb-light border relative -left-0.5 border-afb-light cursor-pointer h-full py-1 rounded-3xl flex justify-center text-white" style="width: 390px; font-weight: 300; font-size: 24px;">
                第一步：上传二维码
              </div>
              <div data-v-8aa184b6="" @click="zh" class="h-full cursor-pointer rounded-3xl flex justify-center py-1 text-afb-light select-none" style="width: 390px; font-weight: 300; font-size: 24px;">
                第二步：生成活码
              </div>
            </div>
          </div>
          <div data-v-8aa184b6="" data-v-25858e0c="" class="main mx-auto relative shadow-afb-bg px-10 pb-5 mt-24 text-afb-gray">



            <div data-v-8aa184b6="" class="mx-auto w-full">
              <form data-v-8aa184b6="" class="el-form mt-4 mb-4">
                <div data-v-8aa184b6="" class="el-form-item">
                  <label class="el-form-item__label">
                    <div data-v-8aa184b6="" class="font-bold">
          活码名称
        </div>
                  </label>
                  <div class="el-form-item__content">
                    <div data-v-8aa184b6="" class="el-input">
                      <input type="text" autocomplete="off" placeholder="请输入您的活码名称，例如：XXX活动群活码（选填）" class="el-input__inner">

                    </div>
                  </div>
                </div>
                <div data-v-8aa184b6="" class="el-form-item flex flex-col text-left">
                  <label class="el-form-item__label"><div data-v-8aa184b6="" class="font-bold">
          二维码管理
          <i data-v-8aa184b6="" class="el-icon-s-opportunity text-afb-light ml-4">

          </i>
                    <span data-v-8aa184b6="" class="font-normal text-afb-light">tips:</span>
                    <span data-v-8aa184b6="" class="font-normal text-ss">最多可将200张静态二维码合并成一个活码</span>
                  </div>
                  </label>

                  <div class="el-form-item__content"> <table data-v-8aa184b6="" class="w-full">
                    <thead data-v-8aa184b6="">
                    <tr data-v-8aa184b6="" class="bg-indigo-50 text-center">
                      <th data-v-8aa184b6="" class="pl-2 w-10"><label data-v-8aa184b6="" class="el-checkbox">
                        <el-checkbox v-model="checked"></el-checkbox>
                    </label>
                    </th>
                      <th data-v-8aa184b6="" class=" w-20">
          优先级
        </th>
                      <th data-v-8aa184b6="" class=" w-32">
          二维码文件名
        </th>
                      <th data-v-8aa184b6="" class=" w-44">
          群码名称
        </th>
                      <th data-v-8aa184b6="" class=" w-28">
          失效日期
        </th>
                      <th data-v-8aa184b6="" class=" w-24">
          访问上限
        </th>
                      <th data-v-8aa184b6="" class=" w-24">
          累计扫码
        </th>
                      <th data-v-8aa184b6="" class=" text-left">
          操作
        </th>
                    </tr>
                    </thead>
                    <tbody data-v-8aa184b6="">
                    <tr data-v-8aa184b6="">
                      <td data-v-8aa184b6="" colspan="8">
                        <div data-v-8aa184b6="">
              <div data-v-8aa184b6=""  @click="zh" class=" border-dashed border-2 w-full py-2 text-center cursor-pointer select-none">
              <span data-v-8aa184b6="" class="text-lg">+</span> 添加二维码
          <span data-v-8aa184b6="">（已添加 0 张）
          </span>
              </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
                <div data-v-8aa184b6="" class="el-form-item">
                  <label class="el-form-item__label">
                    <div data-v-8aa184b6="" class="font-bold mr-4">
                      二维码切换方式
                    </div>
                  </label>
                  <div class="el-form-item__content">
                    <div data-v-8aa184b6="" role="radiogroup" class="el-radio-group">
                      <template>
                        <el-radio-group v-model="radio">
                          <el-radio :label="3" @change="rollovers='二维码访问人数达到访问上限后，自动切换至下一个二维码'">顺序切换</el-radio>
                          <el-radio :label="6" @change="rollovers='用户扫描二维码后，将在所上传的二维码中随机一个进行展示'" >随机切换</el-radio>
                          <el-radio :label="9" @change="rollovers='根据二维码的优先级顺序，平均展示给访问用户'">轮询切换</el-radio>
                        </el-radio-group>
                      </template>
                    </div>
                    <div data-v-8aa184b6="" class="h-full py-2 leading-3 text-afb-light border-blue-200 border rounded w-full bg-blue-50">
                      <i data-v-8aa184b6="" class="el-icon-info ml-4 mr-1"></i>

                      <span data-v-8aa184b6="">{{ rollovers }}</span>
                    </div>

                  </div>
                </div>
              </form>
            </div> <div data-v-8aa184b6="" class="w-full flex justify-center">
            <div data-v-8aa184b6="" @click="zh" class="flex justify-center items-center text-xl border border-afb-light rounded bg-afb-light text-white mt-4 cursor-pointer" style="width: 224px; height: 56px;">
              生成活码
            </div>
          </div>
          </div>
        </div>
      </div>

      <div>
        <div data-v-25858e0c="" class="flex items-center flex-col pb-32"><h2 class=" text-3xl mt-20">
          我们服务的客户
        </h2> <h3 class=" text-gray-500 mt-5 font-light ">
          覆盖教培、金融、医美、家装、企服、制造、零售、电商、餐饮等多个领域
        </h3> <div class="flex flex-wrap justify-between" style="width: 1175px;"><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_1.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_2.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_3.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_4.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_5.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_6.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_7.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_8.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_9.png" width="100%" alt=""></div><div class=" mt-8" style="width: 18%;"><img src="../assets/res/images/home_cs_10.png" width="100%" alt=""></div></div></div>
      </div>

      <div>
        <div data-v-657275de="" data-v-25858e0c="" class="text-afb-gray mt-10">
          <div data-v-657275de="" class="summary bg-gradient-to-br from-blue-600 to-blue-400 flex items-center justify-center">
            <div data-v-657275de="" class=" flex flex-col items-center">
              <p data-v-657275de="" class="text-white sm:text-4xl text-2xl py-2">
          简单易用的活码工具
        </p>
              <p data-v-657275de="" class="text-white text-lg py-4">
          灵活配置，无需埋点轻松完成数据统计
        </p>
            </div>
            <div data-v-657275de="" class=" sm:block ml-40">
              <button data-v-657275de="" @click="zh" class=" bg-white text-afb-light rounded text-lg" style="width: 170px; height: 50px; border-width: 0px;">
                立即体验
              </button>
            </div>
          </div>
        </div>
      </div>



    </div>

    <Foot ref="foot" ></Foot>
  </div>
</template>

<script>
  import Header from "./header";
  import Foot from "./foot";
  export default {
    name: "Home_hm",
    components: { Header:Header,Foot:Foot},
    data() {
      let phone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if (value.match(/0?(13|14|15|16|17|18|19)[0-9]{9}/) == null) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      let code = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else if (value.match(/^\d{6}$/) == null) {
          callback(new Error('请输入六位验证码'));
        } else {
          callback();
        }
      };
      let pass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 5 || value.length > 20) {
          callback(new Error('请输入正确的密码'));
        } else {
          callback();
        }
      };
      let agreement = (rule, value, callback) => {
        if (value){
          callback();
        } else {
          callback(new Error('请阅读并勾选用户协议'));
        }
      };
      return {
        url:"",
        time: 0,
        radio: 3,
        rollovers: "二维码访问人数达到访问上限后，自动切换至下一个二维码",
        activeName: '1',
        uniqueID: "",
        captcha: "",
        captchaUrl: "",
        captchaStr: "",
        checked:false,
        captchaDialog: false,
        wxScene: "",
        wxInterval1: "",
        wxInterval2: "",
        wxQrCodeUrl: "",
        activName: 'first',
        isVip: false,
        isshow:false,
        disabled: false,
        btnTxt: "获取验证码",
        btnLoading: false,
        loginBtnTxt: "登入",
        isGuest: true,
        user_info: {},
        expireSeconds: 0,
        expireTxt: "未获取",
        codeForm: {
          phone: '',
          code: '',
          agreement: true,
        },
        passForm: {
          phone: '',
          pass: '',
          agreement: true,
        },
        rules: {
          phone: [
            { validator: phone, trigger: 'blur' }
          ],
          code: [
            { validator: code, trigger: 'blur' }
          ],
          pass: [
            { validator: pass, trigger: 'blur' }
          ],
          agreement: [
            { validator: agreement, trigger: 'blur' }
          ],
        },


      }
    },
    mounted() {
      const token = this.$storeLocal.get('token');
      const user_info = this.$storeLocal.get('userInfo');
      const times = Date.parse(new Date())/1000;

      if (token !== null && token !== '' && token !== undefined) {
        if (user_info.expire_date > times){
          this.isVip = true;
        }
        this.isGuest = false;
        this.user_info = user_info;
      }

    },

    methods: {
      async zh() {
        if(this.isGuest){
          this.$refs.header.isshow=true;
          return;
        }

        this.$router.push('/tabs/liveCode');
      },
      change(){
        console.log('111')
      },


    }


  }
</script>

<style>
  .app{
    background-color: #ffffff;
  }
  .gold {
    color: #FFD700;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }
  .agreement{
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
  }
  button {
    cursor: pointer;
  }
  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }
  .gray-back {
    background-color: #F5F5F5!important;
  }
  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }

  .float-nav-box .div-box .sw-qrcode {
    position: absolute;
    top: 280px;
    left: -190px;
  }

  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }


  .conversion {
    width: 100%;
  }


  .conversion .features .input-box input {
    width: 570px;
    height: 41px;
    font-size: 30px;
    border: 1px #BFBFBF solid;
    border-right: 0;
    vertical-align: bottom;
  }

  .conversion .features .input-box button {
    width: 120px;
    height: 45px;
    outline: none;
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
  }

  .conversion .features .input-box a {
    width: 120px;
    height: 45px;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
    display: inline-block;
    line-height: 45px;
  }


  .conversion .box {
    width: 100%;
    background-color: #ffffff;
  }


  .conversion .box .management .icon-box div {
    width: 25%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    color: #333333;
    font-size: 18px;
  }

  .conversion .box .management .icon-box div i {
    font-size: 60px;
  }


  .conversion .box .management .remark div {
    width: 23%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #666666;
    padding: 0 1%;
    text-align: left;
  }


  .conversion .box .control .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .control .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }

  .conversion .box .controls .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .controls .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }

  .conversion .boxs .contact .icon-box div {
    width: 240px;
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }


  .conversion .boxs .contact .icon-box div .icons i {
    line-height: 90px;
    font-size: 40px;
  }


  .conversion .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .conversion .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }

  .conversion .box .copyright div span {
    display: inline-block;
    padding: 0 10px;
  }

  .conversion .box .copyright div span a {
    color: #666666;
  }


  .conversion .box .list-box .link-list a {
    color: #00aaee;
  }

  .conversion .box .list-box .link-list table {
    border-bottom: 1px solid #e6e6e6;
    width: 978px;
    table-layout: fixed;
  }

  .conversion .box .list-box .link-list tr th {
    border-top: 1px solid #e6e6e6;
    padding: 0 5px;
    color: #333;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #f5f5f5;
    font-weight: normal;
    line-height: 34px;
  }

  .conversion .box .list-box .link-list tr td {
    border-top: 1px solid #e6e6e6;
    padding: 10px 5px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .conversion .box .list-box .link-list tr:hover td {
    background-color: #f2faff;
  }

  .conversion .box .list-box .link-list .refresh button {
    width: 100px;
    height: 40px;
    display: block;
    font-size: 16px;
    color: #fff;
    border: none;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background-color: #008df2;
    border-radius: 5px;
  }

  .conversion .box .list-box .link-list .refresh button:hover {
    opacity: .8;
    filter: alpha(opacity=80);
  }

  .conversion .box .message_intro .introduce a {
    width: 30%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    color: #666666;
    padding: 0 1%;
    text-align: left;

  }

  .contactusdiyou .hoverbtn span {
    width: 30px;
    height: 19px;
    line-height: 19px;
    text-align: center;
    overflow: hidden;
    float: left;
  }

  .contactusdiyou .conter .con1 dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }


  .kefuQQ a {
    background: url(../assets/images/index/button-custom-qq.gif) no-repeat;
    width: 70px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .kefuQQ a:hover {
    background: url(../assets/images/index/button-custom-qq-h.gif) no-repeat;
  }

  .contactusdiyou .qqcall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall .f3 img {
    width: 150px;
    height: auto;
  }

  .contactusdiyou .dytimer span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
  }

  .userProtocol .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .userProtocol .box {
    width: 100%;
  }


  .userProtocol .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .userProtocol .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }


  .userProtocol .box .copyright div span a {
    color: #666666;
  }

  .userProtocol h3, h1 {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .userProtocol h1 {
    font-size: 25px;
    text-align: center;
    margin-bottom: 25px;
  }

  .userProtocol ol {
    margin-bottom: 20px;
    text-indent: 2em;
    line-height: 25px
  }



  .problem .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }

  .problem .problem-style li {
    font-size: 16px;
    line-height: 30px
  }

  .problem .problem-style .problem-img img {
    height: 800px;
    width: 90%
  }

  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }


  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }

  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }

  /*api文档*/
  .user-console .u-rig {
    width: 1200px;
    min-height: 780px;
    margin: 0 auto;
  }

  .user-console h2.title {
    border-left: 4px solid #008bff;
    height: 20px;
    line-height: 20px;
    padding-left: 5px;
    margin: 10px 0 20px 0;
    font-size: 22px;
    font-weight: 500;
  }

  .icon-blue{
    color: #008df2;
  }
  .banner {
    background: url(../assets/res/images/banner_bg.3052e53.png) 50% no-repeat;
    background-position: 100% 80%;
  }
  .h-80 {
    height: 20rem;
  }


  .text-afb-gray {
    --tw-text-opacity: 1;
    color: rgba(47,73,94,var(--tw-text-opacity));
  }


  .py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .container {
    width: 100%;
  }
  .justify-center {
    justify-content: center;
  }
  .items-center {
    align-items: center;
  }
  .flex-col {
    flex-direction: column;
  }
  .h-60 {
    height: 15rem;
  }
  .flex {
    display: flex;
  }

  .font-light {
    font-weight: 300;
  }
  .mb-10 {
    margin-bottom: 2.5rem;
  }
  .mt-5 {
    margin-top: 1.25rem;
  }
  .btn-ani {
    -webkit-animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
    animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
  }
  .btn-ani {
    -webkit-animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
    animation: btnScale-data-v-108d3240 6s cubic-bezier(.1,.2,.9,1) infinite;
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);
  }
  .shadow-xl {
    box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
  }

  .py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255,255,255,var(--tw-bg-opacity));
  }
  .border-white {
    --tw-border-opacity: 1;
    border-color: rgba(255,255,255,var(--tw-border-opacity));
  }
  .border {
    border-width: 1px;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .w-44 {
    width: 11rem;
  }


  .container {
    /*max-width: 640px;*/
  }
  .container {
    width: 100%;

  }
  .text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .mt-10 {
    margin-top: 2.5rem;
  }
  /*.border-afb-light, .hover\:border-afb-light:hover {*/
  /*   --tw-border-opacity: 1;*/
  /*  border-color: rgba(61,88,219,var(--tw-border-opacity));*/
  /*}*/

  .rounded-3xl {
    border-radius: 1.5rem;
  }

  .cursor-pointer {
    cursor: pointer;
  }


  .w-full {
    width: 100%;
  }

  .relative {
    position: relative;
  }

  .sm\:block {
    display: block;
  }
  .hidden {
    display: none;
  }

  .left-0 {
    left: 0;
  }

  .text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .mt-8 {
    margin-top: 2rem;
  }

  .text-white {
    --tw-text-opacity: 1;
    color: rgba(255,255,255,var(--tw-text-opacity));
  }
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .bg-afb-light {
    --tw-bg-opacity: 1;
    background-color: rgba(61,88,219,var(--tw-bg-opacity));
  }
  .text-gray-500 {
    --tw-text-opacity: 1;
    color: rgba(107,114,128,var(--tw-text-opacity));
  }

  .text-xl {
    font-size: 1.25rem;
  }

  .text-center {
    text-align: center;
  }

  .border {
    border-width: 1px;
    border: #0a9dc7;
  }
  .sm\:flex {
    display: flex;
  }
  .pb-24 {
    padding-bottom: 6rem;
  }

  .mb-12 {
    margin-bottom: 3rem;
  }
  .mt-20 {
    margin-top: 5rem;
  }
  .main[data-v-8aa184b6] {
    width: 1000px;
  }

  .shadow-afb-bg {
    --tw-shadow: 0 0 50px rgba(56,100,137,0.1);
  }
   .shadow-afb-bg {
    box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
  }

  .pb-5 {
    padding-bottom: 1.25rem;
  }
  .px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .mt-24 {
    margin-top: 6rem;
  }
  .border-afb-light, .hover\:border-afb-light:hover {
    --tw-border-opacity: 1;
    border-color: rgba(61,88,219,var(--tw-border-opacity));
  }

  .border {
    border-width: 1px;
  }

  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
  .mt-4 {
    margin-top: 1rem;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  .el-form-item:after, .el-form-item:before {
    display: table;
    content: "";
  }
  [data-v-8aa184b6] .el-form-item__label {
    text-align: left;
  }

  .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }


  .el-form-item__content:after, .el-form-item__content:before {
    display: table;
    content: "";
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100%;
  }
  .el-form-item__content:after {
    clear: both;
  }
  .el-form-item:after {
    clear: both;
  }
  .el-form-item {
    margin-bottom: 22px;
  }

  .text-left {
    text-align: left;
  }
  .flex-col {
    flex-direction: column;
  }
  [data-v-8aa184b6] .el-form-item__label {
    text-align: left;
  }

  .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }

  .ml-4 {
    margin-left: 1rem;
  }
  .el-icon-s-opportunity:before {
    content: "\e7aa";
  }


  .font-normal {
    font-weight: 400;
  }
  .font-normal {
    font-weight: 400;
  }
  .text-ss {
    font-size: .66666666rem;
  }
  table {
    border-collapse: collapse;
  }
  table {
    text-indent: 0;
    border-color: inherit;
  }
  .el-form-item__content {
    line-height: 40px;
    position: relative;
    font-size: 14px;
  }
  .text-center {
    text-align: center;
  }
  .bg-indigo-50 {
    --tw-bg-opacity: 1;
    background-color: rgba(238,242,255,var(--tw-bg-opacity));
  }

  .border-dashed {
    border-style: dashed;
    border-color: rgb(46, 106, 177);
  }
  .border-2 {
    border-width: 2px;
  }
  .select-none {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .el-form-item {
    margin-bottom: 22px;
  }
  el-form-item:after, .el-form-item:before {
    display: table;
    content: "";
  }
  .font-bold {
    font-weight: 700;
  }
  .mr-4 {
    margin-right: 1rem;
  }
  .pb-32 {
    padding-bottom: 8rem;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .justify-between {
    justify-content: space-between;
  }
  .summary[data-v-657275de] {
    width: 100%;
    height: 280px;
    background: url(../assets/res/images/footer_bg.png) 50% no-repeat;
  }
  .to-blue-400 {
    --tw-gradient-to: #60a5fa;
  }
  .from-blue-600 {
    --tw-gradient-from: #2563eb;
    --tw-gradient-stops: var(--tw-gradient-from),var(--tw-gradient-to,rgba(37,99,235,0));
  }
  .bg-gradient-to-br {
    background-image: linear-gradient(to bottom right,var(--tw-gradient-stops));
  }
  .justify-center {
    justify-content: center;
  }
  .sm\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .ml-40 {
    margin-left: 10rem;
  }
  .text-afb-light {
    --tw-text-opacity: 1;
    color: rgba(61,88,219,var(--tw-text-opacity));
  }
  .text-lg, .text-xl {
    line-height: 1.75rem;
  }
  .text-lg {
    font-size: 1.125rem;
  }
  .el-tabs--border-card>.el-tabs__header{
    background-color: #ffffff;
    border-bottom: 0px;
    margin: 0;
    border-radius: 50px;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    border: #2e6ab1 1px solid;
    height: 48px;
    line-height: 40px;

  }
  .el-tabs__item {
     /*padding: 0 80px;*/
     height: 44px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    position: relative;
    border: 0px;
  }
  .el-tabs__nav {
    width: 100%;
    white-space: nowrap;
    position: relative;
    transition: -webkit-transform .3s;
    -webkit-transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s,-webkit-transform .3s;
    float: left;
    z-index: 0;
    line-height: 48px;
  }
  tabs__item.is-top:nth-child(2) {
     padding-left: 20%;
  }
  tabs__item.is-top:nth-child(2) {
    /* padding-left: 0; */
  }
  .el-tabs__item{line-height: 48px;}
  .el-tabs--bottom .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--bottom.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2), .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
     /*padding-left: 80px;*/
  }
  .el-tabs--top .el-tabs__item.is-top:last-child {
     /*padding-right: 80px;*/
  }
  .el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child, .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
    /*padding-right: 80px;*/
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #e7ebfd;
    font-weight: 600;
    color: rgba(61,88,219,var(--tw-text-opacity));
    border-radius: 50px;
    height: 48px;

     color: #409EFF;
     /*background-color: #FFF;*/
    /*border-right-color: #DCDFE6;*/
    /*border-left-color: #DCDFE6;*/
  }
  .app{
    background-color: #ffffff;
  }
  .gold {
    color: #FFD700;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #ffffff;
  }

  button {
    cursor: pointer;
  }

  .blue-btn {
    background-color: #008DF2;
  }

  .green-btn {
    background-color: #07CC00;
  }

  .gray-back {
    background-color: #F5F5F5!important;
  }

  .pl-10 {
    padding-left: 10%;
  }


  .conversion {
    width: 100%;
  }

  .conversion .features .input-box input {
    width: 570px;
    height: 41px;
    font-size: 30px;
    border: 1px #BFBFBF solid;
    border-right: 0;
    vertical-align: bottom;
  }

  .conversion .features .input-box button {
    width: 120px;
    height: 45px;
    outline: none;
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
  }

  .conversion .features .input-box a {
    width: 120px;
    height: 45px;
    vertical-align: bottom;
    color: #ffffff;
    font-size: 16px;
    display: inline-block;
    line-height: 45px;
  }


  .conversion .box {
    width: 100%;
    background-color: #ffffff;
  }



  .conversion .box .management .icon-box div {
    width: 25%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    color: #333333;
    font-size: 18px;
  }

  .conversion .box .management .icon-box div i {
    font-size: 60px;
  }



  .conversion .box .management .remark div {
    width: 23%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    color: #666666;
    padding: 0 1%;
    text-align: left;
  }



  .conversion .box .control .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .control .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }


  .conversion .box .controls .text .title span:nth-child(1) {
    height: 100%;
    display: inline-block;
    font-size: 40px;
    color: #333333;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
    padding-right: 25px;
  }

  .conversion .box .controls .text .title span:nth-child(2) {
    height: 100%;
    display: inline-block;
    font-size: 22px;
    color: #666666;
    text-align: left;
    line-height: 45px;
    vertical-align: top;
  }



  .conversion .boxs .contact .icon-box div {
    width: 240px;
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .conversion .boxs .contact .icon-box div .icons i {
    line-height: 90px;
    font-size: 40px;
  }


  .conversion .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .conversion .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }

  .conversion .box .copyright div span {
    display: inline-block;
    padding: 0 10px;
  }

  .conversion .box .copyright div span a {
    color: #666666;
  }


  .conversion .box .list-box .link-list a {
    color: #00aaee;
  }

  .conversion .box .list-box .link-list table {
    border-bottom: 1px solid #e6e6e6;
    width: 978px;
    table-layout: fixed;
  }

  .conversion .box .list-box .link-list tr th {
    border-top: 1px solid #e6e6e6;
    padding: 0 5px;
    color: #333;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: #f5f5f5;
    font-weight: normal;
    line-height: 34px;
  }

  .conversion .box .list-box .link-list tr td {
    border-top: 1px solid #e6e6e6;
    padding: 10px 5px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .conversion .box .list-box .link-list tr:hover td {
    background-color: #f2faff;
  }



  .conversion .box .list-box .link-list .refresh button {
    width: 100px;
    height: 40px;
    display: block;
    font-size: 16px;
    color: #fff;
    border: none;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background-color: #008df2;
    border-radius: 5px;
  }

  .conversion .box .list-box .link-list .refresh button:hover {
    opacity: .8;
    filter: alpha(opacity=80);
  }



  .conversion .box .message_intro .introduce a {
    width: 30%;
    height: 100%;
    display: inline-block;
    vertical-align: top;
    font-size: 20px;
    color: #666666;
    padding: 0 1%;
    text-align: left;

  }



  .contactusdiyou .hoverbtn span {
    width: 30px;
    height: 19px;
    line-height: 19px;
    text-align: center;
    overflow: hidden;
    float: left;
  }



  .contactusdiyou .conter .con1 dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }



  .kefuQQ a {
    background: url(../assets/images/index/button-custom-qq.gif) no-repeat;
    width: 70px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  .kefuQQ a:hover {
    background: url(../assets/images/index/button-custom-qq-h.gif) no-repeat;
  }





  .contactusdiyou .qqcall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }


  .contactusdiyou .weixincall dl dt {
    width: 31px;
    height: 31px;
    float: left;
    position: relative;
    top: 32px;
  }

  .contactusdiyou .weixincall .f3 {
    float: right;
    width: 73px;
    height: auto;
    margin-right: 69px;
    display: inline;
  }

  .contactusdiyou .weixincall .f3 img {
    width: 150px;
    height: auto;
  }



  .contactusdiyou .dytimer span {
    display: block;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #fff;
  }
  /*用户协议*/
  .userProtocol {
  }

  .userProtocol .bg-color {
    background-color: white;
    width: 1200px;
    height: 60px;
    text-align: center;
  }

  .userProtocol .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }


  .userProtocol .box {
    width: 100%;
  }


  .userProtocol .box .copyright {
    width: 1200px;
    height: 140px;
    padding-top: 40px;
    text-align: center;
    margin: 0 auto;
    color: #666666;
  }

  .userProtocol .box .copyright div {
    width: 100%;
    height: 14px;
    font-size: 14px;
    margin-bottom: 25px;
  }


  .userProtocol .box .copyright div span a {
    color: #666666;
  }

  .userProtocol h3, h1 {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .userProtocol h1 {
    font-size: 25px;
    text-align: center;
    margin-bottom: 25px;
  }

  .userProtocol ol {
    margin-bottom: 20px;
    text-indent: 2em;
    line-height: 25px
  }


  /*问题*/

  .problem .bg-color a {
    color: black;
    font-size: 20px;
    line-height: 60px;
  }



  .problem .problem-style .problem-text {
    font-size: 16px;
    text-indent: 2em;
    margin: 15px 15px;
  }

  .problem .problem-style li {
    font-size: 16px;
    line-height: 30px
  }


  .problem .problem-style .problem-img img {
    height: 800px;
    width: 90%
  }

  /*浮动导航*/
  .float-nav-box {
    width: 80px;
    height: auto;
    background-color: #008DF2;
    color: #FFFFFF;
    position: fixed;
    top: 50%;
    right: 0;
    margin-top: -230px;
    padding: 0 10px;
  }

  .float-nav-box .div-box {
    width: 100%;
    height: 70px;
    text-align: center;
    padding-top: 22px;
    cursor: pointer;
  }

  .float-nav-box .div-box i {
    font-size: 30px;
  }

  .float-nav-box .div-box .qrcode-box {
    width: 160px;
    height: 190px;
    background-color: #FFFFFF;
    box-shadow: 0 0 10px #D9D9D9;
    border-radius: 8px;
    display: none;
  }

  .float-nav-box .div-box:hover .qrcode-box{
    display: block;
  }

  .float-nav-box .div-box .app-qrcode {
    position: absolute;
    top: 0;
    left: -190px;
  }

  .float-nav-box .div-box .gzh-qrcode {
    position: absolute;
    top: 100px;
    left: -190px;
  }

  .float-nav-box .div-box .kf-qrcode {
    position: absolute;
    top: 190px;
    left: -190px;
  }

  .float-nav-box .div-box .sw-qrcode {
    position: absolute;
    top: 280px;
    left: -190px;
  }

  .float-nav-box .div-box .qrcode-box .img-box {
    width: 140px;
    height: 170px;
    /*z-index: 99;*/
    position: absolute;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 10px;
  }

  .float-nav-box .div-box .qrcode-box .img-box img {
    width: 140px;
    height: 140px;
  }

  .float-nav-box .div-box .qrcode-box .img-box div {
    width: 140px;
    height: 20px;
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #333333;
    margin-top: 5px;
  }

  .float-nav-box .div-box .qrcode-box span {
    display: block;
    position: absolute;
    top: 30px;
    right: -10px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 10px #D9D9D9;
    background-color: #ffffff;
    transform: rotate(45deg);
    /*z-index: 88;*/
  }

  .line-bottom {
    border-bottom: 1px solid #FFFFFF;
  }




  .qrCode{
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border: 1px solid #d7dae2;
    position: relative;
  }
  .header-right .item a{
    color: #666666;
  }
  .vcode{
    width: 200px;
    margin-right: 20px;
  }
  .sendBtn{
    width: 140px;
  }
  .login_btn{
    width: 100%;
  }
  .box-card{
    width: 400px;
    /*height: 500px;*/
    margin: 100px auto;

  }
  .countdown{
    width: 100%;
    height: 30px;
    font-size: 14px;

    text-align: center;
  }
  .code-div{
    width: 100%;
    height: 100%;

  }
  .image-slot{
    width: 200px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    background-color: rgba(0,0,0,0.1);
    position: absolute;
    top: 0;
    left: 0;
  }
  .image-slot i{
    color: #808080;
    font-size: 50px;
  }
  .agreement{
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
  }
  .copyright{
    width: 100%;
    color: #666666;
    text-align: center;
  }
  .captcha-img{
    display: inline-block;
    width: 110px;
    height: 36px;
    padding: 2px 0;
    margin-left: 10px;
    vertical-align: top;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item+.el-tabs__item, .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child {
     margin-left: 0px;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item {
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
     border: 0px ;
     margin-top: 0px;
    color: #909399;
  }
</style>
